
class PresetItemDetailCell extends MUICollectionViewCell
{
    private nameLabel:MUILabel = null;
    private settingsButton:MUIButton = null;
    private imageView:MUIImageView = null;

    awakeFromHTML()
    {
        this.nameLabel = MUIOutlet(this, "product-lbl", "MUILabel");
        this.settingsButton = MUIOutlet(this, "product-settings-btn", "MUIButton");
        this.settingsButton.setAction(this, function (control, index){
            this.showCellSettingsPreset();
        })
        this.imageView = MUIOutlet(this, 'product-img','MUIImageView');
    }

    private _presetItem:PresetItem = null;
    set item(i:PresetItem)
    {
        //SWITCH between PresetCategory, PresetProduct, PresetMenu

        if (!i) return;

        this._presetItem = i;

        if (i instanceof PresetProduct) {
            let p = i as PresetProduct;
            if(p.product?.name)
                this.nameLabel.text = p.product.name;

        } 
        else if ( i instanceof PresetMenu) {
            this.nameLabel.text = "Menu " + i.orderIndex;
        } 
        else if (i instanceof PresetCategory) {
            let c = i as PresetCategory;
            this.nameLabel.text = c.name;
        } 
        else if (i instanceof PresetBlank) {

            this.nameLabel.text = "Blank " + i.orderIndex;

        } else if (i instanceof PresetItem) {

            this.nameLabel.text = "PresetItem " + i.orderIndex;
            
        } else {
            //should not get here.
            console.error("Didn't select any preset object");
        }


        // switch(i.className){
        //     case 'PresetProduct':
        //         this.nameLabel.text = "Product" + i.orderIndex;
        //     break;

        //     case 'PresetCategory':
        //         this.nameLabel.text = "Category" + i.orderIndex;
        //     break;

        //     case PresetMenu:
        //         this.nameLabel.text = "Menu" + i.orderIndex;
        //     break;

        //     case PresetItem:
        //         this.nameLabel.text = "PresetItem" + i.orderIndex;
        //     break;
        // }

        //more cell properties here
        // if (i.orderIndex){
        //     this.nameLabel.text = i.orderIndex;
        // }
        
        if (i.presetCategory ? (i.presetCategory.image ? true: false) : false) {
            this.imageView.setImage(i.presetCategory.image);
        }
        
    }

    private showCellSettingsPreset() {
               
        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("PRESET_OPTIONS", "PRESET OPTIONS"), MIOLocalizeString("CHOOSE_AN_ACTION", "CHOOSE AN ACTION"), MUIAlertViewStyle.Default);    

        // avc.addTextFieldWithConfigurationHandler(this, function(textField:MUITextField) {
        //     textField.setPlaceholderText(MIOLocalizeString("NAME", "NAME"));
        // });

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("MOVE_PRESET_INTO_CATEGORY", "MOVE_PRESET_INTO_CATEGORY"), MUIAlertActionStyle.Default, this, function(this:PresetItemDetailCell){
            this.showMoveIntoCategory();
        }));

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("EDIT_PRESET_ITEM", "EDIT PRESET ITEM"), MUIAlertActionStyle.Default, this, function(){
            this.showEditPresetItem();            
        }));

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("DELETE_PRESET_ITEM", "DELETE PRESET ITEM"), MUIAlertActionStyle.Cancel, this, function(this:PresetItemDetailCell){
            if (this._presetItem) DBHelper.deleteObjectFromMainContext(this._presetItem, true);
        }));

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('CANCEL',"CANCEL"), MUIAlertActionStyle.Cancel, null, null));
        AppHelper.sharedInstance().presentViewController( avc, true );
    }

    private showEditPresetItem() {
        if (this._presetItem instanceof PresetCategory) {
            let vc = ProductPresetCategoryDetailViewController.newInstance();
            vc.item = this._presetItem;            
            AppHelper.sharedInstance().presentViewController(vc, true);
        }
    }

    private showMoveIntoCategory(){
        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("MOVE_PRESET_INTO_CATEGORY", "MOVE_PRESET_INTO_CATEGORY"), MIOLocalizeString("CHOOSE_A_CATEGORY", "CHOOSE A CATEGORY"), MUIAlertViewStyle.Default);    

        let pf = "deletedAt = null && presetCategory" + ( this._presetItem.presetCategory == null ? " = null" : ".identifier = " + this._presetItem.presetCategory.identifier );
        let categories = DBHelper.queryObjectsFromMainContext("PresetCategory", [MIOSortDescriptor.sortDescriptorWithKey("name", true)], MIOPredicate.predicateWithFormat( pf ) );

        for (let i = 0; i < categories.length; i++) {
            let c = categories[i] as PresetCategory;
            avc.addAction(MUIAlertAction.alertActionWithTitle(c.name, MUIAlertActionStyle.Default, this, function(this:PresetItemDetailCell){
                this.moveIntoCategory(c);
            }));
        }

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null));

        AppHelper.sharedInstance().presentViewController( avc, true );
    }

    private moveIntoCategory(category:PresetCategory) {
        this._presetItem.presetCategory = category;
        DBHelper.saveMainContext();
    }

}